import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 235px 0 235px;
  padding: 18px 0;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 1000px) {
    margin: 0 30px;
  }
`;

export const Heading = styled.h1`
  margin: 0;
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: 700;
  font-size: 48px;
  line-height: 65.47px;
  letter-spacing: 1.5px;

  /* black */

  color: #000000;
`;

export const SubHeading = styled.h2`
  margin: 0;
  font-family: Nunito Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 0.5px;

  /* secondary Dark */

  color: #D67723;
`;

export const Text = styled.p`
margin: 0;
font-family: Nunito Sans;
font-style: normal;
font-weight: 700;
font-size: 18px;
line-height: 30px;
/* or 167% */

letter-spacing: 0.5px;

/* grey 900 */

color: #444444;`;